/**
 * 菜单翻译工具函数
 * 用于将数据库中的菜单名称转换为当前语言的文本
 */

import menuTranslations from '@/lang/menuTranslations'

/**
 * 翻译菜单名称
 * @param {string} menuName - 数据库中的菜单名称（中文）
 * @param {string} lang - 当前语言代码
 * @returns {string} 翻译后的菜单名称
 */
export function translateMenuName(menuName, lang = 'zh-CN') {
  // 如果是中文，直接返回
  if (lang === 'zh-CN') {
    return menuName
  }

  // 查找翻译
  const translation = menuTranslations[menuName]
  
  // 如果找到翻译且当前语言有对应的翻译，返回翻译
  if (translation && translation[lang]) {
    return translation[lang]
  }

  // 如果没有找到翻译，回退到英文
  if (translation && translation['en-US']) {
    return translation['en-US']
  }

  // 如果完全没有翻译，返回原始名称（中文）
  return menuName
}

/**
 * 递归翻译菜单树
 * @param {Array} menuTree - 菜单树数组
 * @param {string} lang - 当前语言代码
 * @returns {Array} 翻译后的菜单树
 */
export function translateMenuTree(menuTree, lang = 'zh-CN') {
  if (!menuTree || !Array.isArray(menuTree)) {
    return []
  }

  return menuTree.map(menu => {
    const translatedMenu = { ...menu }
    
    // 翻译当前菜单名称
    if (menu.name) {
      translatedMenu.name = translateMenuName(menu.name, lang)
    }

    // 递归翻译子菜单
    if (menu.children && menu.children.length > 0) {
      translatedMenu.children = translateMenuTree(menu.children, lang)
    }

    return translatedMenu
  })
}

/**
 * 批量添加菜单翻译（用于动态扩展）
 * @param {Object} newTranslations - 新的翻译对象
 */
export function addMenuTranslations(newTranslations) {
  Object.assign(menuTranslations, newTranslations)
}

export default {
  translateMenuName,
  translateMenuTree,
  addMenuTranslations
}



// WEBPACK FOOTER //
// ./src/utils/menuTranslator.js